<template>
  <div class="wapper">
    <div class="bg-1">
      <img src="@/assets/images/asmi-logo.png" width="106px" height="115px">
      <div class="heading-text">
        <p class="heading" style="animation: blur 10s ease-out infinite;">Explore</p>
        <h2>Signature Towers</h2>
        <h4>Wakad, Pune</h4>
      </div>
    </div>
    <div class="bg-2">
      <p class="head"> <img src="@/assets/images/angle.png"> Click to Watch Project Video</p>
      <div class="vdo-box"><img v-b-modal.projectVideoModal src="@/assets/images/play-btnn.png" class="play-btnn"></div>
      <p class="book-now">View Details and Book Now!</p>
      <button class="project-btn" @click="goToHome">View Project Details</button>
      <br>
      <p class="powered_by">Powered by <span>PropertyPistol&nbsp;Technologies</span></p>
    </div>
    <VirtualTour url="https://www.youtube.com/embed/57jxx5L7ZMw" id="projectVideoModal" />
  </div>
</template>
<script type="text/javascript">
  export default{
    components:{
      VirtualTour:()=>import('@/components/VirtualTour.vue')
    },
    data(){
      return {
      }
    },
    methods:{
      goToHome(){
        this.$store.dispatch('setIsGifLoading', false);
      },
      playVideo(){
      }
    }
  }
</script>
<style scoped>
.full-screen-video{
  height: 100vh;
  width: 100vw;
  object-fit: fill;
  overflow-y: hidden;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1035;
}

@media (max-width:767px){
  .full-screen-video{
    object-fit: cover;
  }
}

.wapper {
  width: 100%;
  text-align: center;
  overflow: hidden;
  font-family: 'Inter';
  font-style: normal;
  height: 100vh;
  background-color: #622453;
  z-index: 1034;
  position: absolute;
  top: 0;
  left: 0;
}

.bg-1 {
  height: 50vh;
  width: 100%;
  background-size: 100% 100%;
  animation: shrink 5s alternate;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 34.38%, rgba(0, 0, 0, 0.5) 64.06%), linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url('../assets/images/bg1.png');


}

@keyframes shrink {
  0% {
    background-size: 110% 110%;
  }

  100% {
    background-size: 100% 100%;
  }
}

.bg-1 .heading {

  font-weight: 600;
  font-size: 15px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #FFFFFF;
  opacity: 0.8;
  padding-top: 39px;
}

.bg-1 h2 {
  font-weight: 700;
  font-size: 26px;
  color: #FFFFFF;
  margin: 10px 0px 8px 0px;
}

.bg-1 h4 {
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
}

.heading-text {
  animation-name: slideUp;
  animation-duration: 4s;
  animation-timing-function: ease-in-out;
  display: block;
}

@keyframes slideUp {

  0%,
  50% {
    transform: translateY(40%);
    opacity: 0;
  }

  60%,
  100% {
    transform: translateY(0);
    opacity: 1;

  }
}

.bg-2 {
  background-image: url('../assets/images/bg-2.png');
  width: 100%;
  height: 50vh;
  background-size: 100% 100%;
  margin-top: -220px;
  padding-bottom: 14px;
  animation-name: slideUp;
  animation-duration: 5s;
  animation-timing-function: ease-in;
  display: block;
}

.bg-2 .head {
  font-size: 12px;
  line-height: 24px;
  color: #FFFFFF;
  opacity: 0.8;
  padding-top: 137px;
}

.vdo-box {
  height: 193px;
  width: 90%;
  margin-left: 5%;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-radius: 8px;
  background-image: url('../assets/images/fast-Intro.gif');
  background-size: 100% 100%;
}

.play-btnn {
  position: relative;
  top: 40%;
  cursor: pointer;
}

.book-now {
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  text-transform: uppercase;
  color: #FFFFFF;
  opacity: 0.8;
  padding-top: 27px;
}

.project-btn {
  height: 56px;
  background: #FFFFFF;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  width: 90%;
  margin-left: 2%;
  font-weight: 700;
  font-size: 19px;
  line-height: 23px;
  border: none;
  color: #6f285e;
}

.powered_by {
  font-weight: 400;
  font-size: 11px;
  line-height: 13px;
  color: rgba(255, 255, 255, 0.5);
  padding-top: 20px;
}

.powered_by span {
  color: rgba(255, 255, 255, 0.9);
}
</style>